const urlName = '/train/v1'
export default API => ({
    findUserTrain({ data, params }) {
        return API({ // 详情列表
            url: `${urlName}/train/student/findUserTrain`,
            params,
            data
        });
    },

    trainList({ data, params }) {
        return API({ //学习列表
            url: `${urlName}/train/student/trainList`,
            params,
            data
        });
    },

    findById({data,params}) {
        return API({ //简介
            url: `${urlName}/train/findById` ,
            params,
            data
        });
    },

    findTrainBasicInfoById({params}) {
        return API({ //简介
            url: `${urlName}/train/findTrainById` ,
            params,
        });
    },
    
    // 我的考试列表
    findMyExamList({params}) {
        return API({
            url: `${urlName}/trainItemExam/findMyExamList`,
            params,
        })
    },
})

